import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { InsAzureMapWidget } from "../chart/insMapChart/insAzureMapWidget";
import { InsDatapointGridWidget } from "../grid/insDatapointGridWidget";
import { useWidgetComponentProps } from "../hooks/use-current-widget";
import { InsMissingChoiceWidget, useGetWidgetMissingChoice } from "./widget-choice";
import { InsWidgetErrorBoundary } from "./insWidgetErrorBoundary";
import { InsChartWidget, InsCustomTableWidget, InsDefaultWidget, InsDescriptionWidget, InsEsgRatingKPIWidget, InsFreeTextWidget, InsKpiDatapointWidget, InsQuartileRanking, InsUNGlobalCompactPrinciplesWidget, InsValuePairDatapointWidget } from "components";
import { ModalName } from "components/modal/types";
import { useRefreshOnUserSettingsChange } from "hooks/widget-data/user-settings/user-settings";
import { widgetSelector } from "store/cross-slice/widgetSelector";
import { WidgetMode } from "store/current-dashboard/types";
import { useSelectedWidget } from "store/template/widgets/add-widget/selectors";
let forceScrollToWidgetId = null;
export const setForceScrollToWidgetId = (widgetId) => {
    forceScrollToWidgetId = widgetId;
};
export var WidgetFactoryComponentNames;
(function (WidgetFactoryComponentNames) {
    WidgetFactoryComponentNames["insDatapointGridWidget"] = "InsDatapointGridWidget";
    WidgetFactoryComponentNames["insValuePairDatapointWidget"] = "InsValuePairDatapointWidget";
})(WidgetFactoryComponentNames || (WidgetFactoryComponentNames = {}));
const InsCaughtWidgetFactory = (props) => {
    const { widgetId } = props;
    let componentName = useSelector((state) => widgetSelector(state, widgetId)?.componentName);
    useRefreshOnUserSettingsChange();
    const missingChoice = useGetWidgetMissingChoice(widgetId);
    if (missingChoice !== null) {
        return React.createElement(InsMissingChoiceWidget, { ...props, choice: missingChoice.value, state: missingChoice.state });
    }
    componentName = props.mode === WidgetMode.Comparison ? props.comparisonComponentName : componentName;
    switch (componentName) {
        case WidgetFactoryComponentNames.insDatapointGridWidget:
            return React.createElement(InsDatapointGridWidget, { ...props });
        case "InsMapWidget":
            return React.createElement(InsAzureMapWidget, { ...props });
        case "InsChartWidget":
            return React.createElement(InsChartWidget, { ...props });
        case "InsUNGlobalCompactPrinciplesWidget":
            return React.createElement(InsUNGlobalCompactPrinciplesWidget, { ...props });
        case "InsEsgRatingKPIWidget":
            return React.createElement(InsEsgRatingKPIWidget, { ...props });
        case "InsValuePairDatapointWidget":
            return React.createElement(InsValuePairDatapointWidget, { ...props });
        case "InsDescriptionWidget":
            return React.createElement(InsDescriptionWidget, { ...props });
        case "InsCustomTableWidget":
            return React.createElement(InsCustomTableWidget, { ...props });
        case "InsQuartileRanking":
            return React.createElement(InsQuartileRanking, { ...props });
        case "InsKpiDatapointWidget":
            return React.createElement(InsKpiDatapointWidget, { ...props });
        case "InsFreeTextWidget":
            return React.createElement(InsFreeTextWidget, { ...props });
        default:
            return React.createElement(InsDefaultWidget, { ...props });
    }
};
export const InsWidgetFactory = (props) => {
    const { sectionId, widgetId } = props, actualSelectedGroupedWidgetId = useSelector((state) => state.currentDashboard.currentStatus?.sections?.[sectionId]?.selectedGroupedWidget?.[widgetId]), dispatch = useDispatch(), finalProps = { ...props }, modalIsOpen = useSelector((state) => state.modals[ModalName.AddWidget]?.isOpen), selectedWidget = useSelectedWidget(), wrappingDivRef = useRef(null);
    const compPropsGroup = useWidgetComponentProps(sectionId, widgetId);
    if (compPropsGroup.widgets?.length > 0) {
        finalProps.groupId = widgetId;
    }
    if (actualSelectedGroupedWidgetId && compPropsGroup.widgets.some((e) => e === actualSelectedGroupedWidgetId)) {
        finalProps.widgetId = actualSelectedGroupedWidgetId;
    }
    else if (compPropsGroup.default) {
        finalProps.widgetId = compPropsGroup.default;
    }
    finalProps.mode = compPropsGroup.mode;
    finalProps.comparisonComponentName = compPropsGroup.comparisonComponentName;
    useEffect(() => {
        if (forceScrollToWidgetId === widgetId && !modalIsOpen && wrappingDivRef.current) {
            wrappingDivRef.current?.scrollIntoView();
            forceScrollToWidgetId = null;
        }
    }, [dispatch, modalIsOpen, selectedWidget, widgetId]);
    const widgetTitle = useSelector((state) => widgetSelector(state, finalProps.widgetId)?.name);
    return (React.createElement(InsWidgetErrorBoundary, { widgetId: finalProps.widgetId, widgetTitle: widgetTitle },
        React.createElement(InsCaughtWidgetFactory, { ...finalProps })));
};
